import { H2Heading } from "../../Headers";
import { ArticleParagraph } from "../../Paragraphs";
import { InfoBox } from "./InfoBox";
import { NonogramCell } from "./NonogramCell";

const PlacementMiniRow = ({ label, placement }) => (
    <div className="mb-3">
        <p className="text-xs font-medium text-gray-500 mb-1">{label}</p>
        <div className="overflow-x-auto">
            <div className="flex gap-1 min-w-max">
                {placement.map((value, index) => (
                    <NonogramCell
                        key={index}
                        index={index}
                        userState={value === 'filled' ? 'filled' : 'crossed'}
                        interactive={false}
                        size="sm"
                    />
                ))}
            </div>
        </div>
    </div>
);

const DeducedMiniRow = ({ label, cells }) => (
    <div className="mb-3">
        <p className="text-xs font-medium text-gray-500 mb-1">{label}</p>
        <div className="overflow-x-auto">
            <div className="flex gap-1 min-w-max">
                {cells.map((value, index) => (
                    <NonogramCell
                        key={index}
                        index={index}
                        userState="unknown"
                        deducedState={value === 'ambiguous' ? null : value}
                        interactive={false}
                        size="sm"
                    />
                ))}
            </div>
        </div>
    </div>
);

export const StageOverlap = ({ leftmost, rightmost, overlapCells }) => {
    if (!leftmost || !rightmost) return null;

    return (
        <div className="my-8">
            <H2Heading>Stage 2 — Push everything left, then push everything right</H2Heading>

            <ArticleParagraph
                lines={[
                    "Pack every block as far left as it will go, respecting any cells you've already marked. Then do the same pushed as far right as possible. These two arrangements show each block's smallest and largest possible position — where a block's own leftmost and rightmost window overlap, that block must fill those cells no matter where it actually ends up.",
                    "This is block-by-block, not a straight comparison of the two rows: a cell can be filled in both arrangements below by two different blocks without being truly guaranteed, so the highlighted row only marks cells proven safe by tracking each block individually."
                ]}
            />

            <PlacementMiniRow label="Pushed left" placement={leftmost} />
            <PlacementMiniRow label="Pushed right" placement={rightmost} />
            <DeducedMiniRow label="Guaranteed by this technique" cells={overlapCells} />

            <InfoBox title="This technique doesn't catch everything" type="info">
                Per-block overlap is a good starting intuition, but it only reasons about each block in isolation. Stage 3 checks every valid arrangement together and can prove cells this simplified technique misses — especially once your marked cells rule out further possibilities.
            </InfoBox>
        </div>
    );
};
